import originAxios from "axios";

const HOST_SERVER = process.env.REACT_APP_API_SERVER || 'http://localhost:8000';
export const KEY_ICARUS_PM = "KEY_ICARUS_PM";
const ACCESS_TOKEN = 'ACCESS_TOKEN';

const HEADERS = {
  "Accept": "application/json",
  "Content-Type": "application/json"
}
const FormDataHeader = { 'Content-Type': 'multipart/form-data' }

function errorhandler(errorRes) {
  const { response } = errorRes;
  if (response) {
    throw { status: errorRes.response.status, data: errorRes.response.data };
  } else {
    throw { data: { message: "error", success: false, error: errorRes } };
  }
}

const axiosInst = originAxios.create({
  baseURL: HOST_SERVER,
});
class MyAxios {
  wait(duration) {
    return new Promise((iResolve) => {
      let id = setTimeout(() => {
        clearTimeout(id);
        iResolve()
      }, duration)
    })
  }
  getImageFile(path) {
    const token = localStorage.getItem(KEY_ICARUS_PM)
    return `${HOST_SERVER}${path}?token=${token}`
  }
  getFullPath(path) {
    return `${HOST_SERVER}${path}`
  }
  getFormDataContentType() {
    return FormDataHeader;
  }
  getHeaders(additional = {}) {
    let newheaders = {},
      authToken = localStorage.getItem(KEY_ICARUS_PM);
    if (authToken) {
      newheaders['Authorization'] = `Bearer ${authToken}`
    }
    return { headers: { ...HEADERS, ...newheaders, ...additional } }

  }
  async responseHandler(response) {
    if (response.headers && response.headers[ACCESS_TOKEN]) {
      localStorage.setItem(KEY_ICARUS_PM, response.headers[ACCESS_TOKEN])
    }
    return response.data
  }
  get(path, newheaders) {
    return axiosInst.get(path, this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler);
  }
  post(path, body, newheaders) {
    return axiosInst.post((HOST_SERVER + path), body, this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler)
  }
  delete(path, newheaders) {
    return axiosInst.delete((HOST_SERVER + path), this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler)
  }
  put(path, body, newheaders) {
    return axiosInst.put((HOST_SERVER + path), body, this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler)
  }
  patch(path, body, newheaders) {
    return new Promise((resolve, reject) => {
      this.getHeaders(newheaders)
        .then(headers => {
          if (body instanceof FormData) {
            headers['Content-Type'] = 'multipart/form-data'
          }
          return axiosInst.patch(HOST_SERVER + path, body, headers)
        })
        .then(res => {
          return this.responseHandler(res)
        }).then(resolve).catch(reject)
    }).catch(errorhandler)
  }
}


export const axios = new MyAxios();